export class CommunicationsConstants {

    // Bootstrap modal element IDs for the Send Email page (kept here so the page TS and template can't drift).
    public static SEND_CONFIRMATION_MODAL_ID = (): string => 'sendConfirmationModal';
    public static SEND_RESULT_MODAL_ID = (): string => 'sendResultModal';
    public static LEAVE_CONFIRMATION_MODAL_ID = (): string => 'communicationsLeaveConfirmationModal';

    // Combined attachment-size ceiling for a single blast. Sits safely below SendGrid's ~30 MB
    // post-encoding message cap. Enforced client-side as a fast-fail; the API is the authority.
    public static MAX_TOTAL_ATTACHMENT_BYTES = (): number => 20 * 1024 * 1024;
    public static MAX_TOTAL_ATTACHMENT_LABEL = (): string => '20 MB';

    // Modal element ids for the attachment pickers (passed to the picker components).
    public static ATTACHMENT_FILE_PICKER_MODAL_ID = (): string => 'attachmentFilePickerModal';
    public static ATTACHMENT_UPLOAD_FOLDER_MODAL_ID = (): string => 'attachmentUploadFolderModal';
}
